import { LOG_OUT, LOG_OUT_DEV } from 'stash/actions';

type Analytics = {
	reset: () => void;
};

type Action = {
	type: string;
};

const segmentMiddleware =
	(analytics: Analytics) =>
	() =>
	(next: (action: Action) => unknown) =>
	(action: Action): unknown => {
		switch (action.type) {
			case LOG_OUT:
			case LOG_OUT_DEV:
				analytics.reset();
				break;
			default:
				break;
		}
		return next(action);
	};

export default segmentMiddleware;
